const scrollToPos = (position) =>  {
  const startPos = window.scrollY || document.documentElement.scrollTop
  const window_center = window.innerHeight / 2 - 40
  const distance = Math.min(position - window_center - startPos, document.documentElement.scrollHeight - window.innerHeight - startPos)
  const duration = 800 // スクロールにかかる時間（ミリ秒）
  
  function easeOutExpo(t, b, c, d) {
    t /= d
    return c * (-Math.pow(2, -10 * t) + 1) + b
  }
  
  function animation(currentTime) {
    if (startTime === undefined) {
      startTime = currentTime
    }
    const timeElapsed = currentTime - startTime
    const scrollPos = easeOutExpo(timeElapsed, startPos, distance, duration)
    window.scrollTo(0, scrollPos)
    if (timeElapsed < duration) {
      requestAnimationFrame(animation)
    }
  }

  let startTime
  requestAnimationFrame(animation)
}

export default scrollToPos
